module.exports = __webpack_public_path__ + "img/Robert Aderholt.b96e2dd3.jpg";